module.exports = __webpack_public_path__ + "img/OpenSans-ExtraBold.2b247aa2.svg";